import ApiService from '@/services/apiService';
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
export default {
  name: 'CoreToolbar',
  props: {
    breadcrumbs: {
      type: Array,
      required: false,
      default: () => null
    },
    userT: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: function () {
    return {
      containerWidth: 0,
      title: null,
      newTicketCount: 0,
      feedbackDialog: false,
      dialogTitle: '',
      dialogType: 'like'
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'refreshToolbar', 'announcements', 'permissions']),
    ...mapState('authentication', ['user', 'isImpersonating']),
    ...mapGetters({
      isFeatureFlagEnabled: 'app/isFeatureFlagEnabled',
      canUseAssistant: 'app/canUseAssistant'
    }),
    shopLink() {
      if (this.$store.state.app.language === 'de') {
        return 'https://digimondo.iot-shop.de';
      }
      return 'https://digimondo.iot-shop.de/en';
    },
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    },
    showTicketNotificationBell() {
      return this.canReadTickets && this.newTicketCount > 0;
    },
    canCreateTickets() {
      return this.permissions['IsFmTicket.create'] || this.permissions['IsFmTicket.manage'];
    },
    canReadTickets() {
      return this.permissions['IsFmTicket.read'] || this.permissions['IsFmTicket.manage'];
    },
    canScheduleExports() {
      return this.permissions['VirtualDevice.read'] || this.permissions['DigitalTwin.read'];
    },
    canShowBulkEditJobs() {
      return this.permissions['all.manage'] || this.permissions['VirtualDevice.manage'] || this.permissions['VirtualDevice.write'] || this.permissions['VirtualDevice.read'];
    },
    setTop() {
      return [this.$store.state.app.bannerHeight ? {
        top: `${this.$store.state.app.bannerHeight}px`
      } : {
        top: '0px'
      }];
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    breadcrumbsWidth() {
      // 440px is a rough estimate for the width of the other components (email-address, buttons, ...)
      // absolute min-width (on mobile, probably) is 240px
      return `${Math.max(240, Math.floor(this.containerWidth - 440))}px`;
    },
    breadcrumbsItems() {
      if ((this.breadcrumbs || []).length) {
        return this.breadcrumbs;
      }
      return [this.$i18n_t(this.$route.meta.i18n)];
    }
  },
  watch: {
    refreshToolbar() {
      this.loadTicketNotifications();
    }
  },
  mounted() {
    this.loadTicketNotifications();
    window.addEventListener('resize', this.debouncedCalculation);
    this.debouncedCalculation();
  },
  destroyed() {
    window.removeEventListener('resize', this.debouncedCalculation);
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    ...mapActions('authentication', ['logout', 'restoreOriginal']),
    debouncedCalculation: debounce(function () {
      const currentWidth = get(this.$refs, 'toolbarContainer.$el', {}).clientWidth;
      this.containerWidth = currentWidth;
    }, 250),
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    toggleAssistant() {
      this.$store.dispatch('app/toggleAssistant');
    },
    onRestore() {
      this.restoreOriginal().then(() => {
        // page reload after successful restoration to ensure clean state
        // the backend has updated the HTTP-only cookie with the original user's token
        this.$snack(this.$i18n_t('Common.snacks.originalUserRestored'), 'success');
        window.location.reload();
      }).catch(error => {
        console.error('Error restoring original user:', error);
        this.$snack(this.$i18n_t('Common.snacks.originalUserRestoreFailed'), 'error');
      });
    },
    onLogout() {
      this.logout().then(() => {
        // Slightly inconvenient to have a full page load here
        // instead of SPA transition. But after an Error Boundary
        // the router stops working, so we use location.href to
        // make sure at least logout returns to the login screen.
        window.location.href = '/#/login';
      }).catch(error => {
        console.error(error);
      });
    },
    loadTicketNotifications() {
      if (this.canReadTickets) {
        // fetch the count of tickets with state 'New'
        ApiService.isFmTicketsCount(this, null, [0]).then(data => {
          this.newTicketCount = data;
        }).catch(error => {
          console.error(error);
        });
      }
    },
    getPath(metaObj) {
      if (metaObj && metaObj.internalHelp) {
        return '/#/help';
      } else {
        return `${this.$store.state.app.docsBaseURL}`;
      }
    },
    openDialog(data) {
      this.dialogTitle = data.title;
      this.dialogType = data.type;
      this.feedbackDialog = true;
    }
  }
};